import { render } from "./FaqSection.vue?vue&type=template&id=00398b6d&scoped=true"
import script from "./FaqSection.vue?vue&type=script&lang=js"
export * from "./FaqSection.vue?vue&type=script&lang=js"

import "./FaqSection.vue?vue&type=style&index=0&id=00398b6d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00398b6d"]])

export default __exports__